import React, { FunctionComponent, useEffect, useState } from 'react';
import { FileImageOutlined, LoadingOutlined } from '@ant-design/icons';
import css from './Image.module.less';
import cn from 'classnames';

interface ImageProps
  extends React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
  url: string;
}

const Image: FunctionComponent<ImageProps> = ({ url, ...rest }) => {
  const [loading, setLoading] = useState(true);
  const [noneImage, setNoneImage] = useState(!url);

  useEffect(() => {
    setNoneImage(!url);
  }, [url]);

  return (
    <>
      {noneImage ? <FileImageOutlined className={cn(css.holder, rest.className)} /> : null}
      {url && loading ? (
        <div className={cn(css.holder, rest.className)}>
          <LoadingOutlined />
        </div>
      ) : null}
      <img
        src={url}
        {...rest}
        alt={rest.alt}
        onLoad={() => {
          setLoading(false);
        }}
        onError={() => {
          setLoading(false);
          setNoneImage(true);
        }}
        hidden={loading || noneImage}
      />
    </>
  );
};

export default Image;
